import { useMemo, useState } from 'react';

import { isDevStage } from '~/swr-hooks/utils';

export type SignUpFormAutoVerifyControls = {
  showSignupAutoVerifyCheckbox: boolean;
  autoVerifyEmail: boolean;
  setAutoVerifyEmail: (checked: boolean) => void;
};

export const useSignUpFormAutoVerifyControls = (): SignUpFormAutoVerifyControls => {
  const showSignupAutoVerifyCheckbox = isDevStage();
  const [autoVerifyEmail, setAutoVerifyEmail] = useState(false);

  return useMemo(
    () => ({
      showSignupAutoVerifyCheckbox,
      autoVerifyEmail,
      setAutoVerifyEmail,
    }),
    [autoVerifyEmail, showSignupAutoVerifyCheckbox],
  );
};
